export enum SceneObjectType {
  Sprite = 'sprite',
  Culling = 'culling',
  Node = 'node',
  RenderTarget = 'renderTarget',
  ScreenAlignment = 'screenAlignment',
  Glow = 'glow',
  Mask = 'mask',
  Button = 'button',
  Text = 'text',
  MultilineText = 'multilineText',
  TtfTextEdit = 'ttfTextEdit',
  TextEdit = 'textEdit',
  Ttf = 'ttf',
  MultilineTtf = 'multilineTtf',
  Sound = 'sound',
  Stream = 'stream',
  NinePatch = 'ninePatch',
  Tile = 'tile',
  Particles2 = 'particles2',
  ProgressBar = 'progressBar',
  Checkbox = 'checkbox',
  VideoSprite = 'videoSprite',
  Texture = 'texture',
}
